import ActiveRecordResource from '../ActiveRecordResource';
import config from 'config';
import { UserDTO } from '../manager';

export interface TagsDTO {
  id?: string;
  title: string;
  created_by: UserDTO;
  created_at: number;
  publish_at?: number;
  published: boolean;
}

export interface ITagsEditForm {
  title: string;
}

export default class Tags extends ActiveRecordResource {
  static path = `${config.backOfficeBasePath}/api/fan_feed/tags`;

  static mapRecords(data) {
    return data.map((item) => this.parseData(item));
  }

  static parseData(data: TagsDTO): Tags {
    let res = new Tags({});

    return Object.assign(res, res._parseData(data));
  }

  title: string = '';
  published: boolean = false;
  createDate: Date;
  publishDate: Date;

  _getModel() {
    return Tags;
  }

  get isPublished() {
    return this.published;
  }

  _parseData(data: TagsDTO) {
    let res: any = {
      id: data.id,
      title: data.title,
      published: data.published,
      createdBy: data.created_by,
      createDate: new Date(data.created_at),
      publishDate: data.publish_at ? new Date(data.publish_at) : null,
    };

    return res;
  }

  prepareForSave(newData: ITagsEditForm): any {
    let { title } = newData;

    let data: any = { title };

    return data;
  }

  async publish(): Promise<Tags> {
    let response = await this._networkLayer.patch(this._prepareUrl(this.id) + '/publish');

    let data = await response.json();

    this._extendData(data);

    return this;
  }

  async share(): Promise<string> {
    let response = await this._networkLayer.patch(this._prepareUrl(this.id) + '/share');
    let {url} = await response.json();

    return url;
  }
}



// WEBPACK FOOTER //
// ./src/api/fan_feed/fan_feed_tags.ts